import { Amplify } from 'aws-amplify'

// Storage Browser's managed adapter supplies the bucket, region, and role
// credentials per request. Amplify's storage APIs still need a global context.
Amplify.configure({})
